import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Optional, for navigation

const Logout = () => {
  const navigate = useNavigate(); // optional, only if using react-router

  const handleLoginClick = () => {
    navigate('/login'); // or replace with your login path
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Typography variant="h6" gutterBottom>
        Redirecting to Cuckoo login page...
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLoginClick}>
        Login
      </Button>
    </Box>
  );
};

export default Logout;
